import ViewItem from './view-item.vue';
export default ViewItem;
